export default {
  login: "api/login",
  forgotPwd: "access/password/reset",
  seller: "access/seller/select",
  signup: "signup/registration/apply",
  signupCheck: "signup/registration/accept",
};
